var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _path6, _path7, _circle, _path8, _linearGradient5, _circle2, _path9, _circle3, _circle4, _circle5, _path10, _path11, _g, _circle6, _path12, _circle7, _circle8, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eye_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 377.838,
    y1: 4.825,
    x2: 220.346,
    y2: 363.307,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.5 127.6c-65.4-50.3-128.9-9.3-199.6-23.8C200.6 89.2 172.2 40.6 91 63 19 82.9-24.6 162.6 14.9 229.3c11.3 19 30.5 33.4 38.3 54.6 12.7 34.3-6.6 60.7-2.8 94.4C66 518.4 280 464.1 358.7 420.5c123.5-68.4 207-220.5 112.8-292.9z",
    opacity: 0.25,
    fill: "url(#eye_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M436.1 244.6c-16.4-17.6-35.1-33-55.7-45.7v-63c0-11-9-20-20-20H115.6c-11 0-20 9-20 20v63C75 211.6 56.3 227 39.9 244.6c-7.2 7.7-7.2 19.7 0 27.4 3.3 3.5 6.7 6.9 10.1 10.3-1.6 1.8-2.5 4.1-2.5 6.6v77.9c0 5.5 4.5 10 10 10h38.1v3.8c0 11 9 20 20 20h156.7c5.8 20.4 24.5 35.3 46.7 35.3 22.5 0 41.4-15.3 46.9-36.1 8.3-2.4 14.4-10.1 14.4-19.2v-63c20.5-12.7 39.3-28.1 55.7-45.7 7.3-7.7 7.3-19.6.1-27.3z",
    opacity: 0.11,
    fill: "#2626bc"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eye_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 29.62,
    y1: 240.254,
    x2: 569.126,
    y2: 240.254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398.4 117.9v244.8c0 11-9 20-20 20H133.6c-11 0-20-9-20-20V117.9c0-11 9-20 20-20h244.8c11 0 20 8.9 20 20z",
    fill: "url(#eye_svg__b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eye_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 113.62,
    y1: 323.954,
    x2: 163.47,
    y2: 323.954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 285v77.9c0 5.5-4.5 10-10 10h-37c-1.8-3-2.8-6.5-2.8-10.3V275h39.8c5.5 0 10 4.5 10 10z",
    fill: "url(#eye_svg__c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eye_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 113.62,
    y1: 254.374,
    x2: 398.38,
    y2: 254.374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M398.4 195v118.8c-41.4 25.6-90.1 40.4-142.4 40.4-52.2 0-101-14.8-142.4-40.4V195c41.4-25.6 90.2-40.4 142.4-40.4s101 14.8 142.4 40.4z",
    fill: "url(#eye_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M454.1 226.6c7.2 7.7 7.2 19.7 0 27.4-49.4 53-119.9 86.1-198.1 86.1-78.2 0-148.6-33.1-198.1-86.1-7.2-7.7-7.2-19.7 0-27.4 49.4-53 119.9-86.1 198.1-86.1s148.7 33.1 198.1 86.1z",
    fill: "#d2deff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M404.8 184.9c-9.5 8.3-21.5 13.7-34.7 14.8-14.5 1.2-28-2.6-39-9.9l-19.5 8.6c-4 1.8-8.1-2.3-6.4-6.3l8.6-19.5c-5.4-8.1-8.9-17.7-9.9-27.9 36.8 6.5 70.9 20.5 100.9 40.2z",
    fill: "#b7c5ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 240.3,
    r: 58.6,
    fill: "#8399fe"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M361.2 417.9c26.8 0 48.6-21.7 48.6-48.6s-21.7-48.6-48.6-48.6H337v97.1h24.2z",
    fill: "#4369fd"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eye_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 185.4,
    y1: 369.37,
    x2: 577.59,
    y2: 369.37
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 337,
    cy: 369.4,
    r: 48.6,
    fill: "url(#eye_svg__e)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M425.6 128.8c2.4-36.9-28-67.3-64.9-64.9-29.9 1.9-54.3 25.8-56.8 55.6-1.2 14.5 2.6 28 9.9 39l-8.6 19.5c-1.8 4 2.3 8.1 6.3 6.3l19.5-8.6c11 7.3 24.5 11.1 39 9.9 29.8-2.5 53.7-26.9 55.6-56.8z",
    fill: "#ffaf10"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.4,
    cy: 124.1,
    r: 6.9,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.8,
    cy: 124.1,
    r: 6.9,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.2,
    cy: 124.1,
    r: 6.9,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.5 358.8h-78c-5.5 0-10-4.5-10-10v-77.9c0-5.5 4.5-10 10-10h77.9c5.5 0 10 4.5 10 10v77.9c.1 5.5-4.4 10-9.9 10z",
    fill: "#ffaf10"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 270.9v77.9c0 5.5-4.5 10-10 10h-16.7c5.5 0 10-4.5 10-10v-77.9c0-5.5-4.5-10-10-10h16.7c5.5 0 10 4.4 10 10z",
    opacity: 0.5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.9 225.8c-1.3 0-2.6-.5-3.5-1.5-2-2-2-5.1 0-7.1l17.7-17.7c2-2 5.1-2 7.1 0s2 5.1 0 7.1l-17.7 17.7c-1.1 1-2.3 1.5-3.6 1.5zM135.6 225.8c-1.3 0-2.6-.5-3.5-1.5-2-2-2-5.1 0-7.1l17.7-17.7c2-2 5.1-2 7.1 0s2 5.1 0 7.1l-17.7 17.7c-1.1 1-2.4 1.5-3.6 1.5zM358.8 282.4c-1.3 0-2.6-.5-3.5-1.5-2-2-2-5.1 0-7.1l17.7-17.7c2-2 5.1-2 7.1 0s2 5.1 0 7.1l-17.7 17.7c-1.1 1-2.3 1.5-3.6 1.5zM332.5 282.4c-1.3 0-2.6-.5-3.5-1.5-2-2-2-5.1 0-7.1l17.7-17.7c2-2 5.1-2 7.1 0s2 5.1 0 7.1L336 280.9c-1 1-2.3 1.5-3.5 1.5z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 240.3,
    r: 46.2,
    fill: "#9fb0fe"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M302.2 240.3c0 25.5-20.7 46.2-46.2 46.2-9.1 0-17.5-2.6-24.6-7.1 3.4.8 7 1.3 10.7 1.3 25.5 0 46.2-20.7 46.2-46.2 0-16.5-8.6-30.9-21.6-39.1 20.4 4.7 35.5 23 35.5 44.9z",
    fill: "#b7c5ff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.2,
    cy: 242.1,
    r: 14.2,
    fill: "#6583fe"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.5,
    cy: 232.6,
    r: 10.6,
    fill: "#d2deff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7 106.7c-3.7 0-7.5-1.4-10.3-4.3-5.7-5.7-5.7-15 0-20.7 5.7-5.7 15-5.7 20.7 0 2.8 2.8 4.3 6.4 4.3 10.3s-1.5 7.6-4.3 10.3c-2.9 3-6.7 4.4-10.4 4.4zm0-19.2c-1.2 0-2.4.4-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5 1.8 1.8 4.7 1.8 6.5 0 .9-.9 1.3-2 1.3-3.3s-.5-2.4-1.3-3.3c-.8-.8-2-1.2-3.2-1.2z",
    fill: "#8399fe"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M438.4 336.1c-3.7 0-7.5-1.4-10.3-4.3-2.8-2.8-4.3-6.4-4.3-10.3 0-3.9 1.5-7.6 4.3-10.3 5.7-5.7 15-5.7 20.7 0 2.8 2.8 4.3 6.4 4.3 10.3s-1.5 7.6-4.3 10.3c-2.9 2.9-6.7 4.3-10.4 4.3zm0-19.2c-1.2 0-2.4.4-3.3 1.3-.9.9-1.3 2-1.3 3.3s.5 2.4 1.3 3.3c1.8 1.8 4.7 1.8 6.5 0 .9-.9 1.3-2 1.3-3.3 0-1.2-.5-2.4-1.3-3.3-.8-.8-2-1.3-3.2-1.3z",
    fill: "#01eca5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.6 51.9h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3H98c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.2-5-5-5zM105.9 393.9h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.2-5-5-5z",
    fill: "#ff7eb8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.8 417.8h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.2-5-5-5z",
    fill: "#01eca5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M348.8 385.2h-19c.5-1.4.8-2.9.8-4.5v-6.3h6.4c2.8 0 5-2.2 5-5s-2.2-5-5-5h-6.4V358c0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.3c0 2.8 2.2 5 5 5s5-2.2 5-5c0-8.5-6.9-15.3-15.3-15.3s-15.3 6.9-15.3 15.3v6.4h-1c-2.8 0-5 2.2-5 5s2.2 5 5 5h1v6.3c0 .7-.3 1.3-.8 1.8-2.1 2.1-2.8 5.3-1.6 8.1s3.8 4.6 6.9 4.6h23.7c2.8 0 5-2.2 5-5s-2.3-5-5-5z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M457.7 223.2c-16.1-17.3-34.3-32.4-54.2-45 15.4-11.3 25.8-29 27.1-49 1.2-19-5.8-37.6-19.2-51-13.4-13.4-32-20.4-51-19.2-32.3 2.1-58.7 27.9-61.4 60.1-.6 6.8-.1 13.5 1.3 19.9-14.5-2.3-29.4-3.5-44.2-3.5-38.9 0-76.6 7.9-111.9 23.6-8.8 3.9-17.3 8.2-25.5 13v-54.2c0-8.3 6.7-15 15-15H282c2.8 0 5-2.2 5-5s-2.2-5-5-5H133.6c-13.8 0-25 11.2-25 25v60.2c-19.9 12.6-38.1 27.6-54.3 45.1-8.9 9.6-8.9 24.6 0 34.2 2.4 2.6 4.9 5.1 7.4 7.6-.8 1.8-1.2 3.8-1.2 5.9v30.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-30.3c0-2.8 2.2-5 5-5h77.9c2.8 0 5 2.2 5 5v77.9c0 2.8-2.2 5-5 5H75.5c-2.8 0-5-2.2-5-5v-19.5c0-2.8-2.2-5-5-5s-5 2.2-5 5v19.5c0 8.3 6.7 15 15 15h33.1c.6 13.2 11.6 23.8 25 23.8h153c7.5 20.6 27.2 35.3 50.3 35.3h24.2c29.5 0 53.6-24 53.6-53.6 0-12.4-4.3-23.9-11.4-33v-34c19.9-12.6 38.3-27.8 54.3-45 9.1-9.5 9.1-24.5.1-34.1zM308.9 119.9c2.3-27.3 24.7-49.3 52.1-51 16.1-1 31.9 4.9 43.3 16.3s17.3 27.2 16.3 43.3c-1.8 27.4-23.7 49.8-51 52.1-12.8 1.1-25.2-2.1-35.8-9.1-.8-.6-1.8-.8-2.8-.8-.7 0-1.4.1-2 .4l-19 8.4 8.4-19c.7-1.6.5-3.4-.4-4.8-7.1-10.6-10.2-23-9.1-35.8zM133.6 377.6c-7.9 0-14.3-6.1-14.9-13.8h34.8c8.3 0 15-6.7 15-15v-17.9c28.1 9.4 57.6 14.2 87.5 14.2 11.5 0 23.1-.7 34.5-2.1-4.5 7.8-7 16.8-7 26.5 0 2.8.2 5.6.6 8.3l-150.5-.2zm159.9-8.2c0-24 19.5-43.6 43.6-43.6s43.6 19.5 43.6 43.6-19.7 43.5-43.7 43.5-43.5-19.5-43.5-43.5zm75.6 42.8c13-9.8 21.4-25.3 21.4-42.8s-8.4-33-21.4-42.8c20.3 3.7 35.7 21.5 35.7 42.8s-15.4 39.1-35.7 42.8zm24.3-85.6c-5.2-4-11.2-6.9-17.7-8.8 6-2.9 11.9-6 17.7-9.4v18.2zm57-76.1c-26.3 28.2-59 50.7-94.6 65.1-.1 0-.2.1-.2.1H337c-14.8 0-28.2 6-37.9 15.8-14.1 2.3-28.6 3.5-43.1 3.5-30 0-59.5-5-87.5-14.8v-49.4c0-8.3-6.7-15-15-15h-78c-2.5 0-4.9.6-7 1.8-2.3-2.3-4.7-4.7-6.9-7.1-5.4-5.8-5.4-14.8 0-20.6 24.6-26.4 53.8-47.2 86.6-61.8 34-15.1 70.3-22.8 107.8-22.8 16 0 31.9 1.4 47.5 4.2 1.3 3.2 2.8 6.2 4.6 9.2l-7.5 17c-1.6 3.7-.8 8 2 10.9s7.2 3.7 10.9 2l17-7.5c10.3 6.3 21.9 9.5 34 9.5 1.9 0 3.9-.1 5.8-.2 8.4-.7 16.3-3 23.5-6.6 20.8 12.7 39.8 28.1 56.5 46 5.5 5.9 5.5 15 .1 20.7z",
    fill: "#0046c1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 305.7c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13-5.8 13-13 13zm0-16c-1.7 0-3 1.4-3 3s1.4 3 3 3 3-1.4 3-3-1.3-3-3-3zM131.7 340c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13-5.9 13-13 13zm0-16c-1.7 0-3 1.4-3 3s1.4 3 3 3c1.7 0 3-1.4 3-3s-1.4-3-3-3zM100.3 329c-1.3 0-2.6-.5-3.5-1.5-2-2-2-5.1 0-7.1l28.4-28.4c2-2 5.1-2 7.1 0s2 5.1 0 7.1l-28.4 28.4c-1 1-2.3 1.5-3.6 1.5z",
    fill: "#ffdbed"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b31a6463abad2ded525f0cdee3cd7456.svg";
export { ForwardRef as ReactComponent };